import styled from 'styled-components';

export const HoverWrapper = styled.div<{
	$linkColour?: string;
	$hasLinkColour?: boolean;
	$linkHoverColour?: string;
	$linkHoverUnderline?: boolean;
}>`
	--block-link-colour: ${props => props.$linkColour || 'initial'};

	${props =>
		props.$linkColour || props.$hasLinkColour
			? `.link-style,
	.link-style * {
		color: var(--block-link-colour, inherit) !important;
	}`
			: ''}

	.link-style:hover,
	.link-style:hover *,
	.link-style-active,
	.link-style-active * {
		${props => (props.$linkHoverColour ? `color: ${props.$linkHoverColour}!important;` : '')}
		${props => (props.$linkHoverUnderline ? 'text-decoration: underline!important;' : '')}
	}
`;
